import appLocaleData from "react-intl/locale-data/br";
import enMessages from "../locales/pt-BR";

const BrLang = {
  messages: {
    ...enMessages
  },
  locale: "pt-BR",
  data: appLocaleData
};
export default BrLang;
